import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Kshema from "../assets/img/Kshema.svg";
import K from "../assets/img/KIcon.svg";
import RightIcon from "../assets/img/RightIcon.svg";
import LeftIcon from "../assets/img/LeftIcon.svg";
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import SpaOutlinedIcon from '@mui/icons-material/SpaOutlined';
import GrassOutlinedIcon from '@mui/icons-material/GrassOutlined';
import "./SideNav.css";
import { Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { handleICVStatusUpdateSlice, handleGetIcvDataSlice, handleICVGetInfoDataSlice } from "../redux/slices/icvActivitySlice";
import { handleCHMPaginationDataSlice, handleFormSubmittedSlice, handleICVActivitiesPaginationDataSlice, handleUpdatePageSlice } from "../redux/slices/globalSlice";
import { handleCHMInfoByIdDataSlice } from "../redux/slices/chmActivitySlice";
import { LoggedUserType } from "../models/GlobalModels";
import { loginSelector } from "../redux/slices/loginSlice";
import { hasModulePermission } from "../utils/RBAC";

const SideNav = ({ toggleSidebar, isOpen }: any) => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const user: LoggedUserType = useSelector(loginSelector).user;
  const { storeCHMPaginationData, storeICVActivitiesPaginationData } = useSelector((state: any) => state.global);
  const [activeModule, setActiveModule] = useState();
  const modules: any = [
    { 
      name: "Crop Health Monitoring (CHM)",
      icon: <SpaOutlinedIcon />,
      path: "/chm",
      requiredPermissions: [],
      requiredRoleId: [],
      applicationTitle: "CHM - Crop Health Monitoring"
    },
    { 
      name: "Insured Crop Verification (ICV)",
      icon: <HowToRegOutlinedIcon />,
      path: "/icv",
      requiredPermissions: ['Completed-ICV-Tab', 'ICV-Activities-Tab', 'ICV-Masters-Tab'],
      requiredRoleId: [1,2,3,4,5,6],
      applicationTitle: "ICV - Insured Crop Verification"
    },
    { 
      name: "Information Education Communication (IEC)",
      icon: <GrassOutlinedIcon />,
      path: "/iec",
      requiredPermissions: ['IEC-Module'],
      requiredRoleId: [],
      applicationTitle: "IEC - Information Education Communication"
    },
  ];

  // Filter modules based on user permissions
  const filteredModules = modules.filter((module: any) => 
    hasModulePermission(user.permissions, module.requiredPermissions, user?.roleId, module.requiredRoleId)
  );

  useEffect(() => {
    let path = window.location.hash?.split('#').pop();
    setActiveModule(filteredModules.find((each: any) => each.path === path)?.name);
    document.title = filteredModules.find((each: any) => each.path === path)?.applicationTitle ?? 'Crop Watch Ops';
  },[window.location.hash, filteredModules]);

  return (
    <div
      className={`bg-white shadow-lg p-4 transition-all ${isOpen ? "w-264" : "w-104"
        }`}
      style={{
        borderTopRightRadius: "40px",
        borderBottomRightRadius: "40px",
        height: "100%",
      }}
    >
      <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
        <div
          onClick={toggleSidebar}
          className={`transition-all sidebar-logo-bg`}
        >
          {isOpen ? (
            <img src={Kshema} alt="Left Icon" className="kshema-logo" />
          ) : (
            <img src={K} alt="Left Icon" className="k-logo" />
          )}
        </div>
        <button className="toggle-btn" onClick={toggleSidebar}>
          {isOpen ? (
            <img src={LeftIcon} alt="Left Icon" />
          ) : (
            <img src={RightIcon} alt="Right Icon" />
          )}
        </button>
      </div>
      <div className="mt-5">
        {isOpen ? (
          <>
            {filteredModules.map((module: any, index: number) => (
              <div
                key={index}
                className={
                  activeModule === module.name
                    ? "sidebar-module-sec-selected"
                    : "sidebar-module-sec"
                }
                style={{
                  width: "100%",
                  border:
                    activeModule === module.name
                      ? "1px solid #B6C4E3"
                      : "1px solid var(--Primary-Primary-2, #B6C4E3)",
                }}
                onClick={() => {
                  setActiveModule(module.name);
                  navigate(module.path);
                  dispatch(handleICVStatusUpdateSlice({}));
                  dispatch(handleGetIcvDataSlice({ data: [], count: 0 }));
                  dispatch(handleICVGetInfoDataSlice({ data: [], count: 0 }));
                  dispatch(handleUpdatePageSlice(false));
                  dispatch(handleCHMInfoByIdDataSlice({}));
                  dispatch(
                      handleCHMPaginationDataSlice({
                          ...storeCHMPaginationData,
                          offset: 0,
                          limit: 25,
                          selectedLimit: 25,
                      })
                  );
                  dispatch(
                      handleICVActivitiesPaginationDataSlice({
                          ...storeICVActivitiesPaginationData,
                          offset: 0,
                          limit: 250,
                          selectedLimit: 250,
                      })
                  );
                }}
              >
                {module.icon}
                {isOpen && (
                  <div className="sidebar-module-name">{module.name}</div>
                )}
              </div>
            ))}
          </>
        ) : (
          <>
            {filteredModules.map((module: any, index: number) => (
              <div className="d-flex align-items-center justify-content-center" key={index}>
                <div
                  className={
                    activeModule === module.name
                      ? "sidebar-module-sec-selected"
                      : "sidebar-module-sec"
                  }
                  style={{ margin: "6px" }}
                  onClick={() => {
                    setActiveModule(module.name);
                    navigate(module.path);
                    dispatch(handleICVStatusUpdateSlice({}));
                    dispatch(handleGetIcvDataSlice({ data: [], count: 0 }));
                    dispatch(handleICVGetInfoDataSlice({ data: [], count: 0 }));
                    dispatch(handleUpdatePageSlice(false));
                    dispatch(handleCHMInfoByIdDataSlice({}));
                    dispatch(
                        handleCHMPaginationDataSlice({
                            ...storeCHMPaginationData,
                            offset: 0,
                            limit: 25,
                            selectedLimit: 25,
                        })
                    );
                    dispatch(
                        handleICVActivitiesPaginationDataSlice({
                            ...storeICVActivitiesPaginationData,
                            offset: 0,
                            limit: 250,
                            selectedLimit: 250,
                        })
                    );
                  }}
                >
                  <Tooltip
                    title={module.name}
                    placement="bottom-end"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: 'black'
                        }
                      }
                    }}
                  >
                    {module.icon}
                  </Tooltip>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default SideNav;
